import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";

interface IChangeAddressPayload {
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    code: string;
    county: string;
    town: string;
}

export const mapUpdateDeliveryAddressPayload = (customerDetails: ICustomerDetails): IChangeAddressPayload => ({
    addressLine1: customerDetails.deliveryAddress.addressLine1,
    addressLine2: customerDetails.deliveryAddress?.addressLine2 ?? "",
    addressLine3: customerDetails.deliveryAddress?.addressLine3 ?? "",
    county: customerDetails.deliveryAddress.county,
    code: customerDetails.deliveryAddress?.eircode ?? "",
    town: customerDetails.deliveryAddress.town,
});
